import script from "./UploadView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadView.vue?vue&type=script&setup=true&lang=ts"

import "./UploadView.vue?vue&type=style&index=0&id=7e799e9a&lang=scss"

const __exports__ = script;

export default __exports__